import { createContext, useContext, useState } from "react";

const MobileSidebarContext = createContext();

export function MobileSidebarProvider({ children }) {
  const [isVisible, setIsVisible] = useState(true);
  const [isHiddenByUser, setIsHiddenByUser] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const value = {
    isVisible,
    setIsVisible,

    isHiddenByUser,
    setIsHiddenByUser,

    isDrawerOpen, 
    setIsDrawerOpen
  };

  return <MobileSidebarContext.Provider value={value}>{children}</MobileSidebarContext.Provider>;
}

export function useMobileSidebarContext() {
  return useContext(MobileSidebarContext);
}
